import { create } from 'zustand';

import { createComposeSnapshotIndexSlice } from './actions';
import type { ComposeSnapshotIndexStore } from './types';
import { subscribeComposeSnapshotChanges } from '../utils/composeSnapshotCache';

export const useComposeSnapshotIndexStore = create<ComposeSnapshotIndexStore>()(
  (set, get, store) => ({
    ...createComposeSnapshotIndexSlice(set, get, store),
  }),
);

subscribeComposeSnapshotChanges((change) =>
  useComposeSnapshotIndexStore.getState().applyChange(change),
);
